import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const dMDomainsCategoryApi = createApi({
  reducerPath: 'dMDomainsCategoryApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['DomainsCategories'],
  endpoints: (builder) => ({
    getDomainsCategories: builder.query({
      query: (params) => ({
        url: `/domains/domain-categories/`,
        params,
      }),
      providesTags: ['DomainsCategories'],
    }),

    createDomainCategory: builder.mutation({
      query: (body) => ({
        url: '/domains/domain-categories/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['DomainsCategories'],
    }),

    getDomainCategoryById: builder.query({
      query: (id) => ({
        url: `/domains/domain-categories/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'DomainsCategories', id }],
    }),

    updateDomainCategoryById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/domains/domain-categories/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['DomainsCategories'],
    }),

    deleteDomainCategoryById: builder.mutation({
      query: (id) => ({
        url: `/domains/domain-categories/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'DomainsCategories', id }],
    }),
  }),
});

export const {
  useGetDomainsCategoriesQuery,
  useLazyGetDomainsCategoriesQuery,
  useCreateDomainCategoryMutation,
  useGetDomainCategoryByIdQuery,
  useUpdateDomainCategoryByIdMutation,
  useDeleteDomainCategoryByIdMutation,
} = dMDomainsCategoryApi;
